namespace $.$$ {
	$mol_style_define($bog_dobro_app_charity_row, {
		padding: $mol_gap.block,
		margin: $mol_gap.block,
		border: {
			radius: $mol_gap.round,
		},
		boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
		background: {
			color: $mol_theme.card,
		},
		gap: $mol_gap.space,
	})
}

